<template>
  <div class="container-hostess-tasks" :style="cssVars()">
    <div class="custom-nav-block" :style="`padding-top: ${barHeight}px;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="handleBack">
        <template #left>
          <!-- 这是黑色返回箭头 -->
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
          <span class="tit-left">
            {{ $t('lang.BaseCommon.k041') }}
          </span>
        </template>
        <template #right>
          <!-- 倒计时 -->
          <div class="tit-right" v-if="wholeTaskTimeSeconds">
            <img src="@/assets/packageAssets/views/P1_Girls/HostessTasks/default/clock1.png" alt="" />
            <span>{{ transformSeconds1(wholeTaskTimeSeconds) }}</span>
          </div>
        </template>
      </van-nav-bar>
    </div>

    <TopTime :onlineTime="onlineTime" :callTime="callTime"></TopTime>
    <div class="main-content">
      <NewTasks v-if="newerTask && newerTask.length > 0" :newerTask="newerTask" :newerTaskTimeSeconds="newerTaskTimeSeconds" />
      <DailyTasks v-if="dailyTask && dailyTask.length > 0" :newerTask="newerTask" :dailyTask="dailyTask" :weekTask="weekTask" />
    </div>
  </div>
</template>

<script>
import TopTime from './components/TopTime.vue'
import NewTasks from './components/NewTasks.vue'
import DailyTasks from './components/DailyTasks.vue'

import { apiFetchHostessTaskPage } from '@/api/imee'
import { mixin } from './mixin.js'
import { pageCssVars } from './z-style-cfg.js'

export default {
  mixins: [mixin, pageCssVars],
  components: { TopTime, NewTasks, DailyTasks },
  data() {
    return {
      newerTask: [],
      dailyTask: [],
      weekTask: [],
      onlineTime: 0,
      callTime: 0,
      wholeTaskTimeSeconds: 0,
      newerTaskTimeSeconds: 0,
      tasksRefreshed: false,
    }
  },
  methods: {
    handleBack() {
      if (this.$route.query.from === 'webpage') {
        this.goPrevious()
        return
      }
      this.closeWeb()
    },
    fetchHostessTaskPage() {
      apiFetchHostessTaskPage().then((res) => {
        if (res) {
          if (!res.error) {
            let newerTaskArr = res.newerTask || []
            newerTaskArr.forEach((item) => {
              if (item.conditions && item.conditions.length) {
                item.customState = this.handleStatus(item.conditions)
              }
              if (typeof item.customState === 'undefined') {
                item.customState = -1
              }
            })
            newerTaskArr = newerTaskArr.sort((a, b) => b.customState - a.customState)
            this.newerTask = newerTaskArr

            let dailyTaskArr = res.dailyTask || []
            dailyTaskArr.forEach((item) => {
              if (item.conditions && item.conditions.length) {
                item.customState = this.handleStatus(item.conditions)
              }
              if (typeof item.customState === 'undefined') {
                item.customState = -1
              }
            })
            dailyTaskArr = dailyTaskArr.sort((a, b) => b.customState - a.customState)
            this.dailyTask = dailyTaskArr

            this.weekTask = res.weekTask || []
            this.onlineTime = res.onlineTimeSeconds || 0
            this.callTime = res.callsTimeSeconds || 0
            this.wholeTaskTimeSeconds = res.wholeTaskTimeSeconds || 0
            this.newerTaskTimeSeconds = res.newerTaskTimeSeconds || 0

            const params = {
              weekRewardCount: res.weekRewardCount || 0,
              dailyRewardCount: res.dailyRewardCount || 0,
            }
            try {
              updateUnreadOfWomenTask.postMessage(JSON.stringify(params))
            } catch (err) {
              console.log('try catch err:', err)
            }
          }
          //
          else {
            const { status } = res.error
            status === 674 && this.appAction('open_user_verify_page')
          }
        }
      })
    },
    handleVisibilityChange() {
      const visibilityState = document.visibilityState || document.webkitVisibilityState || document.mozVisibilityState || 'visible'
      if (visibilityState === 'visible') {
        setTimeout(() => {
          if (!this.tasksRefreshed) {
            window.sessionStorage.setItem('refresh_tasks', 'web')
            this.fetchHostessTaskPage()
          }
        }, 1500)
      }
    },
  },
  created() {
    this.fetchHostessTaskPage()

    this.tasksRefreshed = false
    // 监听客户端-调用任务刷新
    window.hostessTaskRefresh = () => {
      try {
        window.sessionStorage.setItem('refresh_tasks', 'client')
        setTimeout(() => {
          this.fetchHostessTaskPage()
          this.tasksRefreshed = true
        }, 300)
      } catch (err) {
        console.log('try catch', err)
      }
    }
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },
}
</script>

<style lang="less" scoped>
.container-hostess-tasks {
  width: 100%;
  background: var(--theme-page-bg);
  .custom-nav-block {
    background: var(--theme-page-bg);
  }
  .tit-left {
    color: #fff;
  }
  .tit-right {
    display: flex;
    align-items: center;
    font-family: 'Inter-Regular';
    font-weight: 400;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
    > img {
      width: 14px;
      height: 14px;
      margin: 0 4px;
    }
  }
  .main-null {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    margin-top: 140px;
    font-family: 'AlibabaSans';
    font-weight: 400;
    font-size: 16px;
    color: #999999;
    line-height: 25px;
    .null-bg {
      width: 160px;
      height: 160px;
    }
  }
  .main-content {
    height: 100%;
    min-height: 700px;
    padding: 17px;
    background-color: var(--theme-main-content-bg);
    border-radius: 12px 12px 0 0;
  }
}
</style>
